import { render } from "./SignUpView.vue?vue&type=template&id=648daf14&scoped=true&ts=true"
import script from "./SignUpView.vue?vue&type=script&lang=ts"
export * from "./SignUpView.vue?vue&type=script&lang=ts"

import "./SignUpView.vue?vue&type=style&index=0&id=648daf14&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-648daf14"]])

export default __exports__